<template>
  <div class="min-h-screen flex items-center justify-center bg-gray-50">
    <div class="card w-full max-w-md">
      <div class="card-header text-center flex flex-col items-center">
        <img src="/src/imgs/logo.png" alt="Lazily" class="h-12 w-auto mb-2" />
        <h1 class="text-2xl font-bold text-gray-900">Lazily Dashboard</h1>
        <p class="text-gray-600 mt-2">Enter your API key to continue</p>
      </div>
      
      <div class="card-body">
        <form @submit.prevent="handleLogin" class="space-y-4">
          <div class="form-group">
            <label for="apiKey" class="form-label">API Key</label>
            <input
              id="apiKey"
              v-model="apiKey"
              type="password"
              class="form-input"
              :class="{ error: error }"
              placeholder="Enter your API key"
              :disabled="isLoading"
              required
            />
          </div>
          
          <ErrorMessage 
            v-if="error" 
            :message="error" 
            title="Authentication Failed"
            :details="errorDetails"
          />
          
          <button
            type="submit"
            class="btn btn-primary w-full"
            :disabled="isLoading || !apiKey.trim()"
          >
            <span v-if="isLoading" class="spinner mr-2"></span>
            {{ isLoading ? 'Signing in...' : 'Sign In' }}
          </button>
        </form>
        
        <div class="mt-6 text-center">
          <p class="text-sm text-gray-600">
            Don't have an API key? Contact your administrator.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import ErrorMessage from '@/components/common/ErrorMessage.vue'

const router = useRouter()
const authStore = useAuthStore()

const apiKey = ref('')
const error = ref('')
const errorDetails = ref('')
const isLoading = ref(false)

const handleLogin = async () => {
  if (!apiKey.value.trim()) {
    error.value = 'Please enter an API key'
    return
  }

  try {
    isLoading.value = true
    error.value = ''
    errorDetails.value = ''
    
    await authStore.login(apiKey.value.trim())
    router.push('/dashboard')
  } catch (err: any) {
    error.value = err.message || 'Failed to sign in'
    errorDetails.value = err.stack || JSON.stringify(err, null, 2)
  } finally {
    isLoading.value = false
  }
}
</script>
